/**
 * Russia / Belarus (RU, BY) sanctions validation — shared across:
 * - Registration (banner + Next-step toast)
 * - Manage profile (banner, disabled actions)
 * - Specialization: Education & Government (banner, disabled Submit / Choose File)
 * - Renewal & Uplevel (full-page block)
 *
 * TODO(sanctions-ru-by): set SANCTIONS_RU_BY_VALIDATION_ENABLED to `false` to
 * temporarily disable all RU/BY checks across flows.
 */
export const SANCTIONS_RU_BY_VALIDATION_ENABLED = true;

const DEFAULT_RESTRICTED_SANCTION_COUNTRIES = ["RU", "BY"];

export function getRestrictedSanctionCountries() {
  const raw = process.env.REACT_APP_RESTRICTED_COUNTRIES;
  if (!raw || typeof raw !== "string") {
    return DEFAULT_RESTRICTED_SANCTION_COUNTRIES;
  }
  return raw
    .split(",")
    .map((code) => code.trim().toUpperCase())
    .filter(Boolean);
}

/** When SANCTIONS_RU_BY_VALIDATION_ENABLED is false, always returns false (checks skipped). */
export function isRestrictedSanctionCountry(countryCode) {
  if (!SANCTIONS_RU_BY_VALIDATION_ENABLED) {
    return false;
  }
  if (!countryCode || typeof countryCode !== "string") {
    return false;
  }
  return getRestrictedSanctionCountries().includes(countryCode.trim().toUpperCase());
}
